export default __webpack_public_path__ + "static/media/a011-PPII-2.bde8d275.svg";